'use strict';

var twentyninetimes = twentyninetimes || {};

twentyninetimes.form = twentyninetimes.form || function () {

	function init() {
        var fileInputs = document.querySelectorAll('.customform-form input[type="file"]');

        if ( fileInputs ) {
            fileInputs.forEach(input => {
                input.addEventListener('change', handleFileSelect, false);
            });
        }

        var forms = document.querySelectorAll('.customform-form');
        forms.forEach(form => {
            form.addEventListener('submit', function(e) {
                e.target.classList.add('sending');
            });
        });
    }

    function handleFileSelect(evt) {
        var target = evt.target,
            files = target.files,
            list = target.parentNode.parentNode.querySelector('.customform-field-file__list'); // FileList object

        if ( list ) {
            target.parentNode.parentNode.removeChild(list);
        }

        if ( files ) {
            list = document.createElement('ul');
            list.setAttribute('class', 'customform-field-file__list');
            target.parentNode.parentNode.appendChild(list);
        }

        // Loop through the FileList and render image files as thumbnails.
        for (var i = 0, f; f = files[i]; i++) {
            let type = f.type;
            // Only process image files.
            // if (!f.type.match('image.*')) {
            //   continue;
            // }

            var reader = new FileReader();

            // Closure to capture the file information.
            reader.onload = (function(theFile) {
                return function(e) {
                    // Render thumbnail.
                    var span = document.createElement('li'),
                        html = type.match('image.*') 
                            ? ['<figure class="image"><img src="', e.target.result ,'" title="', theFile.name, '"/></figure><span>', theFile.name, '</span>'] 
                            : ['<figure class="file"></figure><span>', theFile.name, '</span>'];

                    span.innerHTML = html.join('');
                    list.appendChild(span, null);
                };
            })(f);

            // Read in the image file as a data URL.
            reader.readAsDataURL(f);
        }
    }
    
	return {
		init : init
	};

}();